export const defaultUpdateMemberPasswordFormPasswordFieldDisplayText = {
    label: 'New password'
};
